import React from 'react';
import { useOfficeListMapState } from '../OfficeListMapV2/hooks';
import { Office } from '../OfficeListMapV2/types';
import OfficeListContainer from './OfficeListContainer';
import style from './OfficeListMapV1.scss';
import OfficeMap from './OfficeMap';

interface OfficeListMapProps {
  offices: Office[] | null;
  groupId?: string;
  practiceId?: string;
}

export default function OfficeListMapV1({ offices, groupId, practiceId }: OfficeListMapProps) {
  const state = useOfficeListMapState({ offices, groupId, practiceId });
  return (
    <div className={style['practice-page']}>
      <OfficeMap
        offices={state.offices}
        activeOffice={state.activeOffice}
        onOfficeHover={state.setActiveOffice}
        hasZoomControl
        viewport={state.viewport}
        onViewportChanged={state.setViewport}
      />
      <div className={style['practice-page__content']}>
        <OfficeListContainer
          loading={state.loading}
          coordinates={state.coordinates}
          setCoordinates={state.setCoordinates}
          location={state.location}
          setLocation={state.setLocation}
          offices={state.offices}
          activeOffice={state.activeOffice}
          onOfficeHover={state.setActiveOffice}
        />
      </div>
    </div>
  );
}
